"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
// import SharePageDialog from "../../src/components/common/SharePageDialog"
// import PrimaryCTAButton from "../CtaAndShareArticle/shared/PrimaryCTAButton"
// import ShareThisArticleButton from "../CtaAndShareArticle/shared/ShareThisArticleButton"
import type { SliceComponentProps } from "../../src/lib/content/legacyBlockTypes"

type TwoCtasProps = SliceComponentProps

const TwoCtas = ({ slice }: TwoCtasProps) => {
  // console.log("slice.primary", slice.primary)

  return [
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      place holder
      {/* <div
        className={
          "font-roboto flex items-center justify-between flex-col min-[600px]:flex-row min-[600px]:w-[445px] mb-[50px] min-[600px]:mb-[60px] h-[117px] min-[600px]:h-unset"
        }
      >
        <PrimaryCTAButton
          text={slice.primary.primary_cta_text}
          href={slice.primary.primary_cta_link.url}
        />
        <ShareThisArticleButton href={slice.primary.secondary_cta_link.url} />
      </div> */}
    </section>,
    // showShareGroupDialog ? renderShareGroupDialog() : null,
  ]
}

export default TwoCtas
